import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        // ── User / entity status ────────────────────────────────
        active:   'bg-success-50 text-success-700',
        inactive: 'bg-neutral-100 text-neutral-500',
        disabled: 'bg-neutral-100 text-neutral-500',
        // ── Roles ───────────────────────────────────────────────
        super_admin: 'bg-tangerine-100 text-tangerine-800',
        admin:       'bg-neutral-100 text-neutral-700',
        // ── Client types ────────────────────────────────────────
        travel_agent: 'bg-blue-50 text-blue-700',
        b2c:          'bg-purple-50 text-purple-700',
        corporate:    'bg-neutral-100 text-neutral-700',
        // ── Hotel retainer status ────────────────────────────────
        paused:     'bg-warning-50 text-warning-700',
        terminated: 'bg-danger-50 text-danger-700',
        // ── Booking status (semantic palette §10.1) ──────────────
        draft:          'bg-neutral-100 text-neutral-700',
        tentative:      'bg-warning-50 text-warning-700',
        confirmed:      'bg-info-50 text-info-700',
        voucher_issued: 'bg-info-50 text-info-700',
        paid:           'bg-success-50 text-success-700',
        completed:      'bg-neutral-100 text-neutral-700',
        released:       'bg-neutral-100 text-neutral-500',
        cancelled:      'bg-danger-50 text-danger-700',
        // ── Fallback ─────────────────────────────────────────────
        default: 'bg-neutral-100 text-neutral-700',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
